var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQlikView = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3_63)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.7515 20.1367L20.6215 17.5041C21.7077 15.7733 22.3518 13.7296 22.3518 11.5386C22.3518 5.37011 17.3439 0.362183 11.1759 0.362183C5.00792 0.362183 0 5.37011 0 11.5386C0 17.7066 5.00792 22.7145 11.1759 22.7145C13.5693 22.7145 15.7975 21.9594 17.6202 20.6707L20.9526 23.4696C20.9526 23.4696 21.45 23.8931 21.8735 23.3958L23.862 21.039C23.8434 21.039 24.2484 20.5421 23.7515 20.1367ZM18.0437 11.5386C18.0437 15.3312 14.969 18.4059 11.1759 18.4059C7.38328 18.4059 4.30808 15.3312 4.30808 11.5386C4.30808 7.74547 7.38328 4.67078 11.1759 4.67078C14.969 4.67078 18.0437 7.74547 18.0437 11.5386Z",
  fill: "#009848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.75677 11.5385C6.75677 9.10819 8.72696 7.138 11.1573 7.138C13.5877 7.138 15.5578 9.10819 15.5578 11.5385C15.5578 13.9689 13.5877 15.9391 11.1573 15.9391C8.72696 15.9391 6.75677 13.9689 6.75677 11.5385Z",
  fill: "#54565B"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3_63"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQlikView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qlik-view.90774d93b233d1f4a8a14d1a8d7e567f.svg";